/**
 * Single source of truth for the product-editor size sets -- imported by
 * SizesPanel, PricingPanel, and the productEditor store's deselectSize.
 * Add a new size HERE, not in a per-file copy.
 *
 * Standard sizes have no per-size pricing. Non-standard (extended) sizes carry
 * per-size pricing (upcharge + margin) that deselectSize must prune. 5XL is
 * included so SanMar EPDD's full extended-size range surfaces (PR-E).
 *
 * Frozen so a consumer cannot mutate the shared source.
 */
export const STANDARD_SIZES = Object.freeze(['XS', 'S', 'M', 'L', 'XL'])
export const NON_STANDARD_SIZES = Object.freeze(['2XL', '3XL', '4XL', '5XL'])

/**
 * New-product default size set (Jake's call): XS-XL plus 2XL; 3XL-5XL stay
 * opt-in. A CANDIDATE set (Jake, 2026-10-07): only the sizes the supplier
 * offers are selected. Used for a new product's first SKU pick
 * (SupplierSkuPanel) and when a confirmed SKU swap leaves no size the new
 * style offers (useSkuSwapCleanup).
 */
export const NEW_PRODUCT_DEFAULT_SIZES = Object.freeze(['XS', 'S', 'M', 'L', 'XL', '2XL'])
